import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { getDictionariesConditionTypesData } from '../../../CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IKnmReasonType } from '../../../APIPackage/CatalogsModule/interfaces/IKnmReasonType';
import { IKnmReason } from '../../../APIPackage/KnmModule/interfaces/IKnmReason';

export const convertKnmDataConditionTypeToFormValue = (
  state: IRootState,
  systemType?: string,
  reason?: IKnmReason | null,
): IKnmReasonType | null | undefined => {
  const conditionTypes = getDictionariesConditionTypesData(state, systemType);
  let initialType = reason?.type;

  if (conditionTypes && initialType) {
    const dictionaryType = conditionTypes.find(x => x.id === initialType?.id && x.name === initialType.name);

    if (dictionaryType) {
      initialType = {
        ervkUuid: initialType.ervkUuid,
        id: initialType.id,
        name: initialType.name,
        code: initialType.code,
        digitCode: initialType.digitCode,
        hasText: dictionaryType.hasText,
        indicatorRiskRequired: dictionaryType.indicatorRiskRequired,
        indicatorRiskRequiredAuto: dictionaryType.indicatorRiskRequiredAuto,
        indicatorRiskRequiredFile: dictionaryType.indicatorRiskRequiredFile,
        approveRequired: dictionaryType.approveRequired,
        dateRequired: dictionaryType.dateRequired,
        dateRequirement: dictionaryType.dateRequirement,
        requirementDetailsRequired: dictionaryType.requirementDetailsRequired,
        detailsRequirement: dictionaryType.detailsRequirement,
        assignmentNumberRequired: dictionaryType.assignmentNumberRequired,
        assignmentDateRequired: dictionaryType.assignmentDateRequired,
        flkRequired: dictionaryType.flkRequired,
        linkOther: dictionaryType.linkOther,
        dateBegin: initialType.dateBegin,
        dateEnd: initialType.dateEnd,
        inspectionResult: initialType.inspectionResult,
        agreement: initialType.agreement,
        knmIdLink: initialType.knmIdLink,
        flagProfvizit: dictionaryType.flagProfvizit,
        lastConductedKnmDateRequired: dictionaryType.lastConductedKnmDateRequired,
        programNumberRequired: dictionaryType.programNumberRequired,
        programFileRequired: dictionaryType.programFileRequired,
        prescriptionDateRequired: dictionaryType.prescriptionDateRequired,
        prescriptionNumberRequired: dictionaryType.prescriptionNumberRequired,
        prosecutorAttachmentRequired: dictionaryType.prosecutorAttachmentRequired,
      };
    }
  }

  return initialType;
};
